module.exports = __webpack_public_path__ + "img/Simple-Upload-2.61ac64e7.png";